module.exports = new __parcel__URL__("soleil-pluie-3.adb896e1.svg").toString();